<template>
  <div style=" min-height: 500px; text-align: left; margin:20px;">
    <div style="position:relative;">
      <Input
        placeholder="请输入"
        style="position: absolute; right: 0;"
        clearable
        v-model="accountFilter"
      >
        <template slot="prefix"><i class="ion-ios-search"></i></template>
      </Input>
      <span
        class="option-block-title"
        style="    vertical-align: initial;margin-right: 15px;"
        >权限管理</span
      >
      <!-- <span
        >默认密码是 Jdbc@kingsoft
        <a @click="copy('Jdbc@kingsoft')">复制</a></span
      > -->
    </div>
    <div style="margin:20px 0;">
      <!-- <Button type="primary" @click="init">获取iamList</Button> -->
      <Form labelWidth="0">
        <FormItem>
          <Table checkType="none" :data="listFilted" resizable>
            <TableColumn key="Account" title="账号名称" />
            <TableColumn key="IsSub" title="账号身份" width="80">
              <template slot-scope="item">
                {{ item.IsSub ? "子账号" : "主账号" }}
              </template>
            </TableColumn>
            <TableColumn key="Phone" title="权限范围">
              <template slot-scope="item">
                {{ item | permission }}
              </template>
            </TableColumn>
            <!-- <TableColumn key="Krn" title="备注" /> -->
            <TableColumn key="b" title="操作" width="150">
              <template slot-scope="item, index">
                <span v-if="!item.IsSub"> - </span>
                <a
                  ><span @click="auth(item, index)" v-if="item.IsSub"
                    >授权管理</span
                  ></a
                >
              </template>
            </TableColumn>
          </Table>
        </FormItem>
      </Form>
    </div>
    <Dialog
      v-model="showAuth"
      size="small"
      title="选择权限"
      :ok="ok"
      @cancel="onCancel"
      @terminate="onCancel"
    >
      <Transfer
        :data="tData"
        leftTitle="未授权"
        rightTitle="已授权"
        :filter="filter"
        keyName="key"
        filterable
        v-model="tDataValue"
        @remove="onRemove"
      >
        <template slot="label" slot-scope="data">
          <div>
            <div>{{ data.label }}</div>
          </div>
        </template>
      </Transfer>
    </Dialog>
    <Dialog
      v-model="showSetPwd"
      size="small"
      :title="currentAccount.pwdTitle"
      :ok="setOk"
      @cancel="onSetCancel"
      @terminate="onSetCancel"
    >
      <Form ref="pwdForm">
        <FormItem
          label="密码"
          model="pwd"
          :rules="{
            required: true,
            maxLength: 14,
            minLength: 6,
            // 密码校验
            pwdCheck: value => {
              let reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=:;,.?]+$)(?![0-9\\W_!@#$%^&*`~()-+=:;,.?]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=:;,.?]{6,14}$/;
              return (
                reg.test(value) ||
                '密码至少包括大写字母、小写字母、数字和符号（如 -!@#$%&^*+=_:;,.? 等）中的三种'
              );
            }
          }"
        >
          <Input type="password" v-model="pwd" />
          <template slot="append">
            <Tooltip
              content="长度为6到14位，至少包括大写字母、小写字母、数字和符号（如 -!@#$%&^*+=_:;,.? 等）中的三种"
              theme="light"
            >
              <Icon class="ion-ios-help-outline" :size="20" color="#aaa" />
            </Tooltip>
          </template>
        </FormItem>
        <FormItem
          label="确认密码"
          model="confirmPwd"
          :rules="{ required: true, equalTo: 'pwd' }"
        >
          <Input type="password" v-model="confirmPwd" />
        </FormItem>
      </Form>
    </Dialog>
  </div>
</template>
<script>
// import { Button, ButtonGroup } from 'kpc/components/button';
import { Form, FormItem } from 'kpc/components/form';
import { copyToClip } from '@/services/utils';
// import { Timeline, TimelineItem } from 'kpc/components/timeline';
import Dialog from 'kpc/components/dialog';
import Transfer from 'kpc/components/transfer';
// import {Steps, Step} from 'kpc/components/steps';
import { Input } from 'kpc/components/input';
import Icon from 'kpc/components/icon';

import { Table, TableColumn } from 'kpc/components/table';
import { Tooltip } from 'kpc/components/tooltip';
import { REGION_LIST } from '@/apis/const';
import { requestDBList } from '@/apis/meta-data';
import { requestIamUserList, requestSetPwd, requestAuth } from '@/apis/jdbc';
export default {
  components: {
    // Button,
    // ButtonGroup,
    Form,
    FormItem,
    // Timeline,
    // TimelineItem,
    Table,
    TableColumn,
    Dialog,
    Transfer,
    Tooltip,
    Icon,
    Input
  },
  destroyed() {
    this.$EventBus.$off('REGION_CHANGED', this.updateRegion);
  },
  created() {
    this.init();
    this.getDbList();
    this.$EventBus.$on('REGION_CHANGED', this.updateRegion);
    this.initRegion();
  },
  filters: {
    permission(item) {
      let ret = '-';
      if (!item.IsSub) {
        return '全部权限';
      }
      if (Array.isArray(item.Permission) && item.Permission.length) {
        ret = item.Permission.join(' / ');
      }
      return ret;
    }
  },
  watch: {
    tDataValue(n, o) {
      console.log(n, o);
    }
  },
  data() {
    return {
      data: [],
      showSetPwd: false,
      showAuth: false,
      currentAccount: {},
      pwd: '',
      confirmPwd: '',
      dbList: [],
      // 左侧的数据
      tData: [],
      // 穿梭框右侧数据
      tDataValue: [],
      accountFilter: '',
      // 数据中心
      regions: REGION_LIST,
      region: {}
    };
  },
  computed: {
    listFilted() {
      return this.accountFilter
        ? this.data.filter(item => item.Account.includes(this.accountFilter))
        : this.data;
    }
  },
  methods: {
    updateRegion() {
      // this.initRegion()
      this.init();
      this.getDbList();
      this.showSetPwd = false;
      this.showAuth = false;
    },
    initRegion() {
      this.region = this.regions.filter(item => {
        if (window.sessionStorage.getItem('regionKey')) {
          return item.code === window.sessionStorage.getItem('regionKey');
        }
      })[0];
    },
    async onRemove() {
      let permissionList = this.tDataValue.map(item => item.Label);
      this.tData = [];
      this.dbList.forEach(db => {
        if (!permissionList.includes(db.label)) {
          this.tData.push(db);
        }
      });
    },
    async getDbList() {
      this.showLoading();
      try {
        let res = await requestDBList();
        this.dbList = res.data.Data;
      } catch (error) {
        this.Message.error(`${error.msg}`);
      }
      this.hideLoading();
    },
    async init() {
      try {
        let res = await requestIamUserList();
        this.data = res.data.Data || [];
      } catch (error) {
        console.log(error);
        this.Message.error(`${error.msg}`);
      }
    },
    reset(item) {
      console.log(item);
      this.currentAccount = item;
      this.pwd = '';
      this.confirmPwd = '';
      this.showSetPwd = true;
    },
    auth(item) {
      console.log(item, this.tData, this.dbList);
      this.showAuth = true;
      this.tDataValue = [];
      this.currentAccount = item;

      this.tData = [];
      this.dbList.forEach(db => {
        if (item.Permission.includes(db.label)) {
          this.tDataValue.push(db);
        } else {
          this.tData.push(db);
        }
      });
    },
    async ok() {
      try {
        let res = await requestAuth({
          Account: this.currentAccount.Account,
          Permission: this.tDataValue.map(item => item.label)
          // user_id: this.currentAccount.Account.split('_')[0]
        });
        console.log(res);
        this.showAuth = false;
        this.init();
        this.Message['success']('操作成功');
      } catch (error) {
        this.Message['error'](` ${error.msg}`);
        console.log(error);
      }
    },
    onCancel() {},
    async setOk() {
      if (!this.pwd || !this.confirmPwd || this.pwd != this.confirmPwd) {
        this.$refs.pwdForm.validate();
        return;
      }
      try {
        let res = await requestSetPwd({
          Account: this.currentAccount.Account,
          Password: this.pwd
          // user_id: this.currentAccount.Account.split('_')[0]
        });
        console.log(res);
        this.Message['success']('操作成功');
        this.showSetPwd = false;
      } catch (error) {
        this.Message['error'](` ${error.msg}`);
        console.log(error);
      }
    },
    onSetCancel() {},
    filter(data, keywords) {
      console.log(data, '11111');
      return data.label.includes(keywords);
    },
    copy(src) {
      try {
        src = src.replace('xxx', this.region.value);
        copyToClip(src);
        this.Message['success']('复制成功');
      } catch (error) {
        this.Message['error']('复制失败');
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.k-form-item .k-label {
  color: #666;
  font-size: 14px;
  display: inline-block;
  // width: 100px
  // text-align: right
  font-weight: normal;
  margin: 0;
  // padding-top: 11px
  // margin-right 20px
}

.k-text {
  margin-right: 0.5em;
  color: #666;
  font-size: 14px;
}
</style>
